import { render, staticRenderFns } from "./ListAddForm.vue?vue&type=template&id=610764a4&"
import script from "./ListAddForm.vue?vue&type=script&lang=js&"
export * from "./ListAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports